// extracted by mini-css-extract-plugin
export default {"wrapper":"Graph_wrapper__1CFEO","label":"Graph_label__6pNbr","bar":"Graph_bar__bpXBz"};